import styled from 'styled-components'

import { theme } from '../../constants'

export type RoleTone = keyof typeof theme.roleColors

export const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`

export const Label = styled.label`
  color: ${theme.colors.textPrimary};
  font-size: ${theme.typography.size.bodySmall};
  font-weight: ${theme.typography.weight.semibold};
  line-height: ${theme.typography.lineHeight.compact};
`

export const InputWrap = styled.div<{ $hasError: boolean; $tone: RoleTone }>`
  min-height: ${theme.layout.controlHeight};
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  padding: 0 ${theme.spacing[3]};
  color: ${theme.colors.textSecondary};
  background: ${theme.colors.surface};
  border: 1px solid
    ${({ $hasError }) => ($hasError ? theme.colors.error : theme.colors.border)};
  border-radius: ${theme.radii.medium};
  transition:
    border-color ${theme.motion.fast} ${theme.motion.easing},
    box-shadow ${theme.motion.fast} ${theme.motion.easing};

  &:focus-within {
    border-color: ${({ $hasError, $tone }) =>
      $hasError ? theme.colors.error : theme.roleColors[$tone].main};
    color: ${({ $hasError, $tone }) =>
      $hasError ? theme.colors.error : theme.roleColors[$tone].strong};
    box-shadow: ${({ $hasError, $tone }) =>
      $hasError
        ? `0 0 0 3px ${theme.effects.errorFocus}`
        : `0 0 0 3px ${theme.roleColors[$tone].focus}`};
  }

  svg {
    flex: 0 0 auto;
  }
`

export const StyledInput = styled.input`
  width: 100%;
  min-width: 0;
  padding: 11px 0;
  color: ${theme.colors.textPrimary};
  background: transparent;
  border: 0;
  outline: 0;
  font-family: ${theme.typography.family};
  font-size: ${theme.typography.size.bodySmall};
  line-height: ${theme.typography.lineHeight.body};

  &::placeholder {
    color: ${theme.colors.textMuted};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const Hint = styled.span<{ $hasError: boolean }>`
  color: ${({ $hasError }) =>
    $hasError ? theme.colors.error : theme.colors.textMuted};
  font-size: ${theme.typography.size.caption};
  line-height: ${theme.typography.lineHeight.compact};
`
